export default {
  judgment: ' Judgment',
  corrigendum: 'Corrigendum', 
  case: 'Case',
  casename: 'Case Name',
  others: 'Other Documents',
  aboutdb: 'About ',
  dbs: 'Databases',
  indivDbs: 'Databases',
  cright: 'Copyright',
  title: "Title",
  captitle: "Cap. Title",
  lang: "Language",
  sortby: "Sort By",
  relevance: "Relevance",
  citfreq: 'Citation Frequency',
  date: 'Date',
  startdate: 'Start Date',
  enddate: 'End Date',
  daterange: "Date Between",
  cap: "Cap. No.",
  capno: "Cap. Number",
  action: 'Action No.',
  pd: 'Practice Directions',
  pd_num: 'No.',
  case_a: 'Case',
  appeal: 'Appeal', 
  appealhis: '{0} History',
  appealhistitle: '{0} History of {1}',
  wdg_relatedcap: 'Related ',
  wdg_relatedcap_nil: 'This Ordinance has no Regulations',
  wdg_status: 'Status',
  wdg_status_filecount: 'File Count',
  wdg_status_judcount: 'Judgment Count',
  wdg_status_dbcount: 'Databases',
  wdg_status_fileunit: 'files',
  wdg_status_updatetime: 'Last Updated',
  wdg_status_foundCount: 'Found Count',
  wdg_jdg: 'Judgment Information',
  wdg_jdg_neutral: 'Neutral Cit.',
  wdg_jdg_pcit: 'Parallel Cit.',
  wdg_legis: 'Legislation Information',
  wdg_legis_info: 'Info',
  wdg_legis_vercount: 'Version Count',
  wdg_legis_latest: 'Latest Version',
  wdg_legis_enact: 'Enacted On',
  wdg_treaty: 'Treaty Information',
  wdg_treaty_cat: 'Category',
  wdg_treaty_body: 'Body',
  wdg_goto: 'Check Official Copy',
  wdg_goto_elegis: 'Hong Kong e-Legislation',
  wdg_goto_elegis_tooltip: 'View the official copy on HKeL',
  wdg_doc: 'Document Info',
  wdg_lang: 'View in Another Language',
  wdg_download: 'Download',
  wdg_viewops: 'Reading Options',
  wdg_viewops_trans: 'This judgment has no translation.',
  wdg_ref_s: 'Look up this section on',
  wdg_ref_l: 'References to this document',
  wdg_ref_d: 'Look up this document on',
  wdg_ref_c: 'Look up this case on',
  wdg_ref_lawcite: 'Search for other documents citing or being cited in this document',
  wdg_ref_lawcite_legis: 'Search for other documents citing or being cited in this document',
  wdg_ref_noteup: 'Search for other documents citing this document',
  wdg_contents: 'Contents',
  wdg_ref_noteup_legis: 'Search for other documents citing this document',
  wdg_translation: 'Translation',
  wdg_judgment_tag: 'Related Concepts',
  warning: 'Caution',
  pastver: 'This is a past version. Select the current version above for the latest version.', 
  compareversion: 'Select two versions to compare',
  compare_explanation: 'Differences between the two versions are highlighted.',
  compare: 'Comparison',
  version: 'Version',
  compare_title: 'Legislation Version Comparison',
  compare_diff: 'There are no changes between the selected versions.',
  filter: 'Narrow By ',
  filter_to: 'to',
  filter_and: 'and',
  totip_preSec: 'Previous section',
  totip_nextSec: 'Next section',
  loading: 'Loading ...',
  rsidetitle: 'Information regarding to this page',
  toc: 'Table of Contents',
  toc_short: 'TOC',
  fullsection: 'Showing Full Content',
  legisdb_filter_hint: 'Click on groups to apply/deselect filter',
  togglehl_hint: 'Click to turn on/ off the highlights of search words',
}